import './css/styles.scss';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function initProduktsektionerSliders() {
	const sliders = Array.from(
		document.querySelectorAll<HTMLElement>('.produktsektioner__slider')
	);
	if (!sliders.length) return;

	const mq = window.matchMedia('(max-width: 768px)');

	const build = () => {
		sliders.forEach((el) => {
			if ((el as any)._swiper) return;
			(el as any)._swiper = new Swiper(el, {
				modules: [Pagination],
				slidesPerView: 1.15,
				spaceBetween: 12,
				watchOverflow: true,
				pagination: {
					el: el.querySelector('.swiper-pagination') as HTMLElement,
					clickable: true,
				},
			});
		});
	};

	const destroy = () => {
		sliders.forEach((el) => {
			const sw = (el as any)._swiper;
			if (sw) {
				sw.destroy(true, true);
				(el as any)._swiper = null;
			}
		});
	};

	const update = () => (mq.matches ? build() : destroy());

	update();
	mq.addEventListener('change', update);
}

document.addEventListener('DOMContentLoaded', initProduktsektionerSliders);
